<mat-card fxLayout="column" style="width: 100%;">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <article>
            <h4 class="chart-two-heading">All Sessions</h4>
        </article>

        <nav class="nv_rt rpd">
            <div style="float: left;" fxLayout="row">
                <div fxLayout="column">
                    <i class="fa fa-share-square-o" aria-hidden="true"
                        style="font-size: 24px; color:#707070; cursor: pointer;"
                        (click)="exportCsvData()"></i>
                </div>
            </div>
        </nav>
    </div>

    <mat-card-content fxLayout="column" fxFlex="100%">
        <div *ngIf="totalDifficultPSets?.length === 0 && !isMessage" class="empty-state-spinner">
            <mat-spinner diameter="20"></mat-spinner>
        </div>
        <span *ngIf="isMessage" class="empty-state-text title-sm">No Sessions</span>
        <div fxLayout="column" fxFlex="100%" [fxHide]="totalDifficultPSets ? totalDifficultPSets?.length == 0 : true">
            <div fxLayout="row" overflowAuto style="max-height: 300px; overflow-y: auto;">
                <table mat-table [dataSource]="dataSource" matSort matSortActive="averageCorrectAnswers"
                    matSortDirection="asc" class="mat-elevation-z8 ovrflw" aria-label="Average Correct Answers list">
                    <ng-container matColumnDef="userName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> User Name </th>
                        <td mat-cell *matCellDef="let element" class="brk_txt" [matTooltip]="element.userName"
                            (click)="openUserDialog(element)" pointer>
                            {{element.userName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="sessionCount">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">Session Count</th>
                        <td mat-cell *matCellDef="let element" class="tabel-element-width text-center">
                            {{element.sessionCount |
                            number: '1.0':'en-US'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="duration">
                        <th mat-header-cell *matHeaderCellDef scope="col"> Duration </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            {{element.duration }}
                        </td>
                    </ng-container>
<!--
                    <ng-container matColumnDef="userRole">
                        <th mat-header-cell *matHeaderCellDef scope="col"> User Role </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            {{element.userRole |
                            number:
                            '1.0':'en-US'}} </td>
                    </ng-container>   -->                

                    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <mat-paginator class="analytic-paginator"
                [pageSize]="5" [length]="totalDifficultPSets?.length" [style.display]="isPage?'none':''"
                [pageSizeOptions]="[5, 10, 25, 100]">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>